import { httpService } from './Service';

const BASE = '/cotacao-moeda-forte';

export const exportarCotacoes = (dataInicial, dataFinal) =>
  httpService.get(BASE + '/exportar', {
    params: { dataInicial, dataFinal },
    responseType: 'blob',
  });

export const importarCotacoes = arquivo => {
  const formData = new FormData();
  formData.append('arquivo', arquivo);
  return httpService.post(BASE + '/importar', formData, {
    'Content-Type': 'multipart/form-data',
  });
};
